"use strict";

var _inherits = require("/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _toArray = require("/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/toArray");

var _classCallCheck = require("/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Ptr = /*#__PURE__*/function () {
  function Ptr(tokens) {
    _classCallCheck(this, Ptr);

    this.tokens = tokens;
  }

  _createClass(Ptr, [{
    key: "toString",
    value: function toString() {
      if (this.tokens.length === 0) {
        return "";
      }

      var tokens = this.tokens.map(function (token) {
        return token.replace(/~/g, "~0").replace(/\//g, "~1");
      });
      return "/".concat(tokens.join("/"));
    }
  }, {
    key: "eval",
    value: function _eval(instance) {
      var _iterator = _createForOfIteratorHelper(this.tokens),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var token = _step.value;

          if (instance.hasOwnProperty(token)) {
            instance = instance[token];
          } else {
            throw new EvalError(instance, token);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return instance;
    }
  }], [{
    key: "parse",
    value: function parse(s) {
      if (s === "") {
        return new Ptr([]);
      }

      if (!s.startsWith("/")) {
        throw new InvalidPtrError(s);
      }

      var _s$split = s.split("/"),
          _s$split2 = _toArray(_s$split),
          tokens = _s$split2.slice(1);

      return new Ptr(tokens.map(function (token) {
        return token.replace(/~1/g, "/").replace(/~0/g, "~");
      }));
    }
  }]);

  return Ptr;
}();

exports.default = Ptr;

var InvalidPtrError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidPtrError, _Error);

  var _super = _createSuper(InvalidPtrError);

  function InvalidPtrError(ptr) {
    var _this;

    _classCallCheck(this, InvalidPtrError);

    _this = _super.call(this, "Invalid JSON Pointer: ".concat(ptr));
    _this.ptr = ptr;
    return _this;
  }

  return InvalidPtrError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.InvalidPtrError = InvalidPtrError;

var EvalError = /*#__PURE__*/function (_Error2) {
  _inherits(EvalError, _Error2);

  var _super2 = _createSuper(EvalError);

  function EvalError(instance, token) {
    var _this2;

    _classCallCheck(this, EvalError);

    _this2 = _super2.call(this, "Error evaluating JSON Pointer: no attribute ".concat(token, " on ").concat(instance));
    _this2.instance = instance;
    _this2.token = token;
    return _this2;
  }

  return EvalError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.EvalError = EvalError;